import { render } from "./market-switcher-trigger.vue?vue&type=template&id=311d692c"
import script from "./market-switcher-trigger.vue?vue&type=script&lang=js"
export * from "./market-switcher-trigger.vue?vue&type=script&lang=js"

import "./market-switcher-trigger.vue?vue&type=style&index=0&id=311d692c&lang=scss"

import exportComponent from "C:\\Users\\craig\\Documents\\Websites\\lyle-scott\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__